/** Root of every /api/learner/* React Query key; invalidating it refreshes all of the user's lists. */
export const LEARNER_QUERY_KEY = 'learner';

/** One user's /api/learner/* query key: [LEARNER_QUERY_KEY, user, ...what]. */
export const learnerQueryKey = (userUid: string | undefined, ...rest: readonly unknown[]) =>
  [LEARNER_QUERY_KEY, userUid ?? 'anonymous', ...rest] as const;
